let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4uhcp")).then(() => parcelRequire('jA3Z9'));